export class Login {
  public Ruc: string;
  public Usuario: string;
  public Clave: string;
  public CodPorv: string;
    codError: any;
    root: any;
  msgError: any;
  success: any;


  constructor(

  ) { }
}
